import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link } from '@mui/material';
import BELogo from '../../assets/logo.png';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) =>
  <Link component={RouterLink}
    sx={{ display: 'contents', }}>
    <img src={BELogo} alt="Home" style={{ width: '250px' }} />
  </Link>
);


Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
